import { render } from "./DownloadTemplateVertical.vue?vue&type=template&id=43fab731&scoped=true&ts=true"
import script from "./DownloadTemplateVertical.vue?vue&type=script&lang=ts"
export * from "./DownloadTemplateVertical.vue?vue&type=script&lang=ts"

import "./DownloadTemplateVertical.vue?vue&type=style&index=0&id=43fab731&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fab731"]])

export default __exports__